import { UserCategorySelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
  category_id: {
    'ui:widget': UserCategorySelectionWidget,
  },
});

export default uiSchema;
